import React, { lazy } from "react";
import { RouteObject } from "react-router-dom";

// export lazy route
const PrivacyPolicy = lazy(() => import("./PrivacyPolicy"));

const PRIVACYPOLICY_ROUTES: RouteObject[] = [
  {
    path: "/public/privacy-policy",
    element: React.createElement(PrivacyPolicy),
  },
];

export default PRIVACYPOLICY_ROUTES;
